import { createPathMesh } from "../../assetBuilders/path";
import { BabylonState } from "../../state";

/**
 * Generates the trace mesh for all positions that have loaded.
 */
export function reloadStalePaths(state: BabylonState) {
  for (const entity of Object.values(state.entities)) {
    if (
      !entity.position ||
      !entity.path ||
      entity.path.load.state !== "stale" ||
      entity.position.cache.load.state !== "loaded"
    ) {
      continue;
    }
    entity.path.mesh?.dispose();
    entity.path.material?.dispose();
    const path = entity.path;
    const mean = entity.position.mean;
    const points = path?.spec.lineWidth
      ? entity.position.cache.allPoints.map((p) => p.subtract(mean))
      : [];
    // TODO: if the mesh creation gets especially complicated, break this up into units of work
    // to let user interactions etc happen.
    const lineWidth = path.spec.lineWidth;
    // Only make a mesh to draw if there is a line to draw.
    if (
      lineWidth !== undefined &&
      isFinite(lineWidth) &&
      lineWidth > 0 &&
      points.length > 0
    ) {
      path.mesh = createPathMesh(
        `${entity.id}.trace`,
        path.spec.color,
        lineWidth,
        points,
        state.context.scene,
      );
      // Invalidate the third-person zoom cache: the new path mesh
      // contributes to the scene-union bounding box that
      // `computeThirdPersonZoom` derives its envelope from.
      state.sceneConfig.entityGeneration =
        (state.sceneConfig.entityGeneration ?? 0) + 1;
    }
    path.load.state = "loaded";
  }
}
